/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.sunnahsky.richtext.facets.blocks'

type $nsid = typeof $nsid

export { $nsid }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
type ByteSlice = {
  $type?: 'com.sunnahsky.richtext.facets.blocks#byteSlice'
  byteEnd: number
  byteStart: number
}

export type { ByteSlice }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
const byteSlice = /*#__PURE__*/ l.typedObject<ByteSlice>(
  $nsid,
  'byteSlice',
  /*#__PURE__*/ l.object({
    byteEnd: /*#__PURE__*/ l.integer({ minimum: 0 }),
    byteStart: /*#__PURE__*/ l.integer({ minimum: 0 }),
  }),
)

export { byteSlice }

/** Block-level rich-text facets not covered by at.markpub.facets.baseBlocks - paragraph alignment and named article typography variants. Same index/features shape as at.markpub.facets.baseBlocks, kept as a separate lexicon rather than a fork of it. An audio-embed facet was considered and descoped, not built. */
type Main = {
  $type?: 'com.sunnahsky.richtext.facets.blocks'
  features: (
    l.$Typed<TextAlign> | l.$Typed<Typography> | l.Unknown$TypedObject
  )[]
  index: ByteSlice
}

export type { Main }

/** Block-level rich-text facets not covered by at.markpub.facets.baseBlocks - paragraph alignment and named article typography variants. Same index/features shape as at.markpub.facets.baseBlocks, kept as a separate lexicon rather than a fork of it. An audio-embed facet was considered and descoped, not built. */
const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    features: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<TextAlign>((() => textAlign) as any),
          /*#__PURE__*/ l.typedRef<Typography>((() => typography) as any),
        ],
        false,
      ),
    ),
    index: /*#__PURE__*/ l.ref<ByteSlice>((() => byteSlice) as any),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Facet feature setting paragraph alignment. The byteSlice provided should span the whole paragraph the alignment applies to. */
type TextAlign = {
  $type?: 'com.sunnahsky.richtext.facets.blocks#textAlign'
  value: 'left' | 'center' | 'right' | 'justify' | l.UnknownString
}

export type { TextAlign }

/** Facet feature setting paragraph alignment. The byteSlice provided should span the whole paragraph the alignment applies to. */
const textAlign = /*#__PURE__*/ l.typedObject<TextAlign>(
  $nsid,
  'textAlign',
  /*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.string<{
      knownValues: ['left', 'center', 'right', 'justify']
    }>(),
  }),
)

export { textAlign }

/** Facet feature marking a paragraph as using a named article typography variant beyond plain body text (e.g. an Arabic-script paragraph or blockquote rendered in a different font/size/justification than the surrounding text). The byteSlice provided should span the whole paragraph the variant applies to. */
type Typography = {
  $type?: 'com.sunnahsky.richtext.facets.blocks#typography'
  value: 'arabicParagraph' | 'arabicQuote' | l.UnknownString
}

export type { Typography }

/** Facet feature marking a paragraph as using a named article typography variant beyond plain body text (e.g. an Arabic-script paragraph or blockquote rendered in a different font/size/justification than the surrounding text). The byteSlice provided should span the whole paragraph the variant applies to. */
const typography = /*#__PURE__*/ l.typedObject<Typography>(
  $nsid,
  'typography',
  /*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.string<{
      knownValues: ['arabicParagraph', 'arabicQuote']
    }>(),
  }),
)

export { typography }
